import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/gei/auxiliaries/client-types/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/gei/auxiliaries/client-types/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/gei/auxiliaries/client-types/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/client-types/create`,  data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/client-types/update`,  data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/client-types/delete/${id}`)
    },
}